//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "followOrderDetail",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    toMore(){
      this.$router.push({name:'sendOrderDetailMore'})
    },
    toBase(){
      this.$router.push({name:'sendOrderDetailBase'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sendOrder/detail.vue